import { find, get, map } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { unsupportedCurrencyWarning } from "helpers/currency"
import { getDefaultCurrencyId as getAccountCurrency } from "modules/account-root/selectors"
import { getModels } from "resources/models"
import { getModelSupportedCurrencies } from "selectors/modelMetadata"

const EMPTY_ARRAY = []
export const getWatchlistId = props => get(props, "params.watchlistId", null)
const EMPTY_OBJECT = {}
export const getWatchlist = state => get(state, "global.data.watchlist.data.watchlist", null)

// The resource slot still holds the PREVIOUS watchlist until the new payload lands, and the shell
// now renders through that window — so anything NAMING or ACTING on it must check first. Separate
// from `getWatchlist`, which is also read without props (getModelId) where the route id is unknown.
export const getCurrentWatchlist = (state, props) => (
  get(state, "global.data.watchlist.id") === getWatchlistId(props) ? getWatchlist(state) : null
)
const getSelectedModel = state => get(state, "modules.watchlistRoot.selectedModel", null)

export const getModelCurrentDate = state => get(state, "global.data.dates.data.model.availability.currentDate", EMPTY_OBJECT)
export const getModelStartDate = state => get(state, "global.data.dates.data.model.availability.securitiesStartDate")
const getDate = state => state.modules.watchlistRoot.selectedDate
const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)

export const getSelectedDate = createSelector(
  [getModelCurrentDate, getDate],
  (currentDate, date) => date?.selectedDate || currentDate,
)

export const getModelId = createSelector(
  [getSelectedModel, getModels, getPortfolios, getWatchlist],
  (selectedModel, models, portfolios, watchlist) => {
    if (watchlist) {
      if (selectedModel) return selectedModel

      return getMostUsedOrDefaultModelId(portfolios, models)
    }

    return null
  },
)

export const getModel = createSelector(
  [getModelId, getModels],
  (selectedModel, models) => find(models, model => model.id === selectedModel),
)

export const getUnsupportedCurrencyWarning = createSelector(
  [getModelSupportedCurrencies, getAccountCurrency],
  unsupportedCurrencyWarning,
)

export const getCurrency = createSelector(
  [getAccountCurrency, getUnsupportedCurrencyWarning],
  (accountCurrency, unsupportedCurrencyWarning) => unsupportedCurrencyWarning ? null : accountCurrency,
)

export const getAllModelIds = createSelector(
  [getModels],
  (models) => map(models, "id"),
)
